import { User } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import SimplizeLogo from "../../../../components/SimplizeLogo";
import { useGetStatsQuery } from "../../../api/nebula-stats/nebulaStatsApi";
import OnboardingWelcome from "../components/onboarding/OnboardingWelcome";
import { isInitStatus } from "../utils/nebulaData";

const OnboardingPage = () => {
  const navigate = useNavigate();

  const { data: statsData, isLoading: isLoadingStats } = useGetStatsQuery({});

  React.useEffect(() => {
    const status = statsData?.data?.status;
    if (!isLoadingStats && status && !isInitStatus(status)) {
      navigate("/");
    }
  }, [statsData, isLoadingStats, navigate]);

  const handleNext = () => {
    navigate("/nebula-init");
  };

  const handleSkip = () => {
    navigate("/");
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col overflow-y-auto transition-colors duration-500 bg-[#F8FDFC]">
      <header className="w-full h-[80px] px-[68px] flex items-center justify-between shrink-0">
        <SimplizeLogo className="h-[32px] w-auto" />
        <button className="w-[40px] h-[40px] rounded-full bg-white border border-[#ececed] flex items-center justify-center text-[#636369] hover:bg-gray-50 transition-colors">
          <User className="w-[20px] h-[20px]" />
        </button>
      </header>

      <div className="flex-1 flex flex-col items-center justify-center px-4">
        <div className="w-full flex justify-center py-10">
          <OnboardingWelcome onNext={handleNext} onSkip={handleSkip} />
        </div>
      </div>
    </div>
  );
};

export default OnboardingPage;
